/**
 * Newsletter band's Klaviyo form, posted in place — sections/newsletter.liquid
 *
 * With a Klaviyo list ID the band renders a plain GET form to the list's own address (live's footer-newsletter, list
 * PChjkS), which still works without this script by opening Klaviyo's page in a new tab. Here it is sent to the
 * list's ajax address instead and the result is shown under the field; on success the field hides, as live's
 * KlaviyoSubscribe did, and dl_subscribe and Klaviyo's identify run as the image-overlay-band form does. If the
 * request cannot be made the form falls back to its plain submission. One delegated listener, so a band the theme
 * editor re-renders keeps working.
 */
if (!window.__newsletterKlaviyoForm) {
  window.__newsletterKlaviyoForm = true;

  /**
   * Writes the copy under the field and moves focus so it is read, as the Shopify form's success render does: an
   * error goes back to the field (which names the message), a success to the message itself (the field is hidden).
   * @param {HTMLFormElement} form
   * @param {string} text
   * @param {boolean} [isError]
   */
  const showMessage = (form, text, isError = false) => {
    const message = form.querySelector('.newsletter__message');
    const email = form.elements.email;

    message.textContent = text;
    email.toggleAttribute('aria-invalid', isError);
    (isError ? email : message).focus();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.newsletter__form[data-ajax-action]')) return;

    const email = form.elements.email;

    if (!email.value.trim() || !email.checkValidity()) {
      event.preventDefault();
      showMessage(form, form.dataset.invalidMessage, true);
      return;
    }

    if (!window.fetch) return;

    event.preventDefault();
    form.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(form.dataset.ajaxAction, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form)),
      });
      const result = await response.json();

      if (result.success) {
        const address = email.value.trim();

        form.classList.add('is-sent');
        showMessage(form, form.dataset.successMessage);
        window.DataLayerUtility?.trackSubscribe(address);

        // Klaviyo's onsite queue, as live's KlaviyoSubscribe identified the subscriber after a signup.
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', { $email: address }]);
        window._learnq.push(['trackActivity']);
      } else {
        showMessage(form, result.errors?.[0] || form.dataset.errorMessage, true);
      }
    } catch {
      form.submit();
    } finally {
      form.removeAttribute('aria-busy');
    }
  });
}
